import type {ReactElement} from 'react';
import React, {useEffect} from 'react';
import {updateOptionsPanelHeight} from '@Components/poster-editor/library/poster-editor-library';
import {ItemContrastOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/item-contrast-option';
import {SlideshowItemContrastOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/slideshow-item-contrast-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';

interface ContrastAdjusmentOptionProps {
  panelId: string;
}

export function ContrastAdjusmentOption({...props}: ContrastAdjusmentOptionProps): ReactElement | null {
  useEffect((): void => {
    updateOptionsPanelHeight(props.panelId, '140px');
  }, []);

  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const activeSlide = activeSlideUID && activeItem?.isSlideshow() ? activeItem.getSelectedSlide() : null;

  if (!activeItem) {
    return null;
  }

  if (activeItem.isSlideshow() && !activeSlide) {
    return null;
  }

  if (activeItem?.isImage() || activeItem?.isVideo() || activeItem.isSticker()) {
    return <ItemContrastOption />;
  }
  if (activeItem?.isSlideshow() || activeSlide?.isMediaSlide()) {
    return <SlideshowItemContrastOption />;
  }

  return null;
}
